import React, { Component } from 'react';

export default class Notifications extends Component {
  render() {
    return (
      <p>Notifications</p>
    );
  }
}
